// extracted by mini-css-extract-plugin
export var black = "_3y-6";
export var brand = "_3y-1";
export var ddefault = "_3y-0";
export var error = "_3y-3";
export var gray = "_3y-2";
export var highContrast = "_3y-8";
export var outline = "_3y-7";
export var success = "_3y-5";
export var warning = "_3y-4";